module.exports = __webpack_public_path__ + "media/images/icon__betPick--none@3x-0a5dcfc955843e8bc5a2c2ddb108c602.png";